export default {
  UNDEFEATED: "UNDEFEATED",
  ONE_LOSS: "ONE_LOSS",
  TWO_LOSS: "TWO_LOSS",
};
